import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { IconButton, Tooltip, withStyles, Typography } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import * as actions from './store/userActivityActions';
import * as action from '../../np-core/Auth/store/authActions';
import {isSuperUser, getDimensionsOfPagination, hasPermission} from '../../sc-utilities';
import { connect } from 'react-redux';
import UserActivityRemoveSession from './UserActivityRemoveSession'
import { BackButton, formatDate, localization } from '../../sc-utilities';
import { CsvBuilder } from 'filefy';
import ExtendSessionModal from "./ExtendSessionModal";
import moment from "moment";

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    typography: {
        marginTop: '6%'
    },
    title: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const UserActivityList = props => {
    const { classes, translations, handleRemoveSession, saveColumnsFilter, activeCustomer, tableColumns, fetchUserActivityDataCount, usersActivities, fetchUserActivityData, tableActions, removeSession, userAgentDialog, tableRef, extendSessionModal, setExtendSessionModal, clientTypes, permissions, extendSession } = props;

    const customExport = (columns, userActivitiesList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        const data = userActivitiesList.map(userActivity => {
            let returnObj = [
                userActivity.User && userActivity.User.Username ? userActivity.User.Username : translations['short_not_assigned'] || 'n/a',
                userActivity.LoginCredential ? userActivity.LoginCredential : translations['short_not_assigned'] || 'n/a',
                userActivity.CreatedAt ? formatDate(userActivity.CreatedAt) : translations['short_not_assigned'] || 'n/a',
                userActivity.LastActivity ? formatDate(userActivity.LastActivity) : translations['short_not_assigned'] || 'n/a',
                userActivity.ExpiresAt ? formatDate(userActivity.ExpiresAt) : translations['short_not_assigned'] || 'n/a',
                userActivity.Status === 'active' ? 'Active' : 'Inactive',
                userActivity.ClientType ? userActivity.ClientType : translations['short_not_assigned'] || 'n/a',
                userActivity.ClientVersion ? userActivity.ClientVersion : translations['short_not_assigned'] || 'n/a',
                userActivity.LoggedWith ? userActivity.LoggedWith : translations['short_not_assigned'] || 'n/a',
                userActivity.HardwareIP ? userActivity.HardwareIP : translations['short_not_assigned'] || 'n/a',
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_user_activity_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const fetching = usersActivities.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            exportFileName: 'UserActivity',
            filterCellStyle: { maxWidth: '200px' },
            search: false,
            exportButton: false,
            minBodyHeight: window.innerHeight - 198 < 300 ? 300 : window.innerHeight - 198,
            maxBodyHeight: window.innerHeight - 198,
            pageSizeOptions: rowsPageSizeInit,
            columnsButton: true,
            exportCsv: customExport,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
            },
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const handleCloseDanger = async () => {
        await removeSession({ SessionID: userAgentDialog.SessionID, ActiveCustomerID: activeCustomer })
        handleRemoveSession();
        tableRef.current && tableRef.current.onQueryChange()

    };

    const extendSessionModalCloseDanger = async () => {
        await extendSession({ SessionID: extendSessionModal?.rowData?.SessionID, ActiveCustomerID: activeCustomer })
        tableRef.current && tableRef.current.onQueryChange()
        setExtendSessionModal({open: false});
    };

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    };

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        q["LastActivity"] = moment.utc(q.LastActivity);
        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await fetchUserActivityDataCount(query);
        if (!query['page'] && !rowsPageSizeInit.includes(query['pageSize'])) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchUserActivityData(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`UserActivity`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    };

    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography>
                    {translations["users_activities"] || 'Users activities'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>

    };

    return (<><MaterialTable
        tableRef={tableRef}
        title={tableTitle()}
        columns={columnObject}
        data={fetchTableData}
        options={tableOptions}
        onChangeRowsPerPage={(size) => {
            setTableOptions({ ...tableOptions, pageSize: size })
            pageSize = size
        }}
        isLoading={fetching}
        localization={localization(translations)}
        onChangeColumnHidden={columnHidden}
        actions={isSuperUser() ? tableActions : null}
        onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
    />
        {userAgentDialog.sessionDialog ?
            <UserActivityRemoveSession handleCloseDanger={handleCloseDanger} removeSession={removeSession} tableRef={tableRef} fetchTableData={fetchTableData} handleRemoveSession={handleRemoveSession} translations={translations} activeCustomer={activeCustomer} userActivityModalState={userAgentDialog}></UserActivityRemoveSession>
            : null}

        {extendSessionModal?.open && hasPermission(permissions, "update_user_session") && <ExtendSessionModal clientType={clientTypes[extendSessionModal?.rowData?.ClientType]} translations={translations} extendSessionModal={extendSessionModal} setExtendSessionModal={setExtendSessionModal} extendSessionModalCloseDanger={extendSessionModalCloseDanger} />}
    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        fetchUserActivityDataCount: filter => dispatch(actions.fetchUserActivityDataCount(filter)),
        fetchUserActivityData: filter => dispatch(actions.fetchUserActivityData(filter)),
        removeSession: queryParams => dispatch(actions.removeSession(queryParams)),
        extendSession: queryParams => dispatch(actions.extendSession(queryParams)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data))
    };
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        usersActivities: state.statistic.usersActivities,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UserActivityList));